import NavTab, { DEFAULT_OPTIONS } from 'CoreComponents/navTab/';

document.querySelectorAll(DEFAULT_OPTIONS['selector']).forEach(navTab => {
  new NavTab(navTab);
});
